<template>
  <div class="style-number-image">
    <template v-if="error">
      /
    </template>
    <template v-else>
      <el-image v-if="imageUrl" :src="imageUrl" :preview-src-list="[imageUrl]" fit="contain" @error="handleError" />
    </template>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class StyleNumberImage extends Vue {
  @Prop({ type: String, required: true }) styleNumber;

  error = false;

  get imageUrl() {
    if (!this.styleNumber) {
      return '';
    }
    return `${process.env.VUE_APP_FEIGE_API}/products/${this.styleNumber.trim()}/image`;
  }

  handleError() {
    this.error = true;
  }
}
</script>

<style lang="scss" scoped>
.style-number-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;

  .el-image {
    width: 100%;
    height: 100%;
  }
}
</style>
